import "./App.css";
import React from "react";
import { TranslationContextProvider } from "./context/TranslateContext";
import From from "./components/from/From";
import To from "./components/to/To";

function App() {
  return (
    <TranslationContextProvider>
      <div className="App">
        <h1>Text To Speech Translate</h1>
        <div className="fromToContainer">
          <From />
          <To />
        </div>
      </div>
    </TranslationContextProvider>
  );
}

export default App;
